import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _989b70dc = () => interopDefault(import('../../../pages/404.vue' /* webpackChunkName: "pages/404" */))
const _83ecbba2 = () => interopDefault(import('../../../pages/offers/_offer.vue' /* webpackChunkName: "" */))
const _e3b94e72 = () => interopDefault(import('../../../pages/partners/_partner.vue' /* webpackChunkName: "" */))
const _38c841f4 = () => interopDefault(import('../../../pages/about-us.vue' /* webpackChunkName: "pages/about-us" */))
const _4a4d76bd = () => interopDefault(import('../../../pages/promotions/_promotion.vue' /* webpackChunkName: "" */))
const _e8ad238a = () => interopDefault(import('../../../pages/blog/index.vue' /* webpackChunkName: "pages/blog/index" */))
const _45b2af8f = () => interopDefault(import('../../../pages/careers.vue' /* webpackChunkName: "pages/careers" */))
const _63a98eda = () => interopDefault(import('../../../pages/charities/index.vue' /* webpackChunkName: "pages/charities/index" */))
const _c4a9f8bc = () => interopDefault(import('../../../pages/guidance-notes.vue' /* webpackChunkName: "pages/guidance-notes" */))
const _0a0f105a = () => interopDefault(import('../../../pages/how-it-works.vue' /* webpackChunkName: "pages/how-it-works" */))
const _acde9cbc = () => interopDefault(import('../../../pages/legal-advice.vue' /* webpackChunkName: "pages/legal-advice" */))
const _7683accf = () => interopDefault(import('../../../pages/newsletter.vue' /* webpackChunkName: "pages/newsletter" */))
const _38e49a26 = () => interopDefault(import('../../../pages/power-of-attorney.vue' /* webpackChunkName: "pages/power-of-attorney" */))
const _57bb13c0 = () => interopDefault(import('../../../pages/pricing.vue' /* webpackChunkName: "pages/pricing" */))
const _5e416e3c = () => interopDefault(import('../../../pages/privacy.vue' /* webpackChunkName: "pages/privacy" */))
const _1d8b2a1b = () => interopDefault(import('../../../pages/safewill-legal-terms.vue' /* webpackChunkName: "pages/safewill-legal-terms" */))
const _b9542954 = () => interopDefault(import('../../../pages/security.vue' /* webpackChunkName: "pages/security" */))
const _5df21fe1 = () => interopDefault(import('../../../pages/terms.vue' /* webpackChunkName: "pages/terms" */))
const _f7fb89e8 = () => interopDefault(import('../../../pages/vault.vue' /* webpackChunkName: "pages/vault" */))
const _236ef488 = () => interopDefault(import('../../../pages/welcome-back.vue' /* webpackChunkName: "pages/welcome-back" */))
const _7b29e43b = () => interopDefault(import('../../../pages/wills.vue' /* webpackChunkName: "pages/wills" */))
const _72d87a61 = () => interopDefault(import('../../../pages/blog/guides/index.vue' /* webpackChunkName: "pages/blog/guides/index" */))
const _76b7623f = () => interopDefault(import('../../../pages/blog/posts/index.vue' /* webpackChunkName: "pages/blog/posts/index" */))
const _7b16d831 = () => interopDefault(import('../../../pages/charities/directory/index.vue' /* webpackChunkName: "pages/charities/directory/index" */))
const _7500c0f7 = () => interopDefault(import('../../../pages/blog/posts/_slug.vue' /* webpackChunkName: "" */))
const _c6206cc6 = () => interopDefault(import('../../../pages/blog/author/_id.vue' /* webpackChunkName: "pages/blog/author/_id" */))
const _7121d919 = () => interopDefault(import('../../../pages/blog/guides/_slug.vue' /* webpackChunkName: "pages/blog/guides/_slug" */))
const _cc53f93e = () => interopDefault(import('../../../pages/invites/_code.vue' /* webpackChunkName: "" */))
const _98173ca8 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/404",
    component: _989b70dc,
    name: "404___au"
  }, {
    path: "/9saver",
    component: _83ecbba2,
    name: "9saver___au"
  }, {
    path: "/aarf-123",
    component: _e3b94e72,
    name: "aarf-123___au"
  }, {
    path: "/about-us",
    component: _38c841f4,
    name: "about-us___au"
  }, {
    path: "/abs",
    component: _4a4d76bd,
    name: "abs___au"
  }, {
    path: "/acf",
    component: _e3b94e72,
    name: "acf___au"
  }, {
    path: "/acon",
    component: _e3b94e72,
    name: "acon___au"
  }, {
    path: "/acrf",
    component: _e3b94e72,
    name: "acrf___au"
  }, {
    path: "/actionaid",
    component: _e3b94e72,
    name: "actionaid___au"
  }, {
    path: "/activ",
    component: _e3b94e72,
    name: "activ___au"
  }, {
    path: "/adelaidefringe-123",
    component: _e3b94e72,
    name: "adelaidefringe-123___au"
  }, {
    path: "/afterpay-day",
    component: _4a4d76bd,
    name: "afterpay-day___au"
  }, {
    path: "/amnesty",
    component: _e3b94e72,
    name: "amnesty___au"
  }, {
    path: "/animalsaustralia-123",
    component: _e3b94e72,
    name: "animalsaustralia-123___au"
  }, {
    path: "/anzgog",
    component: _e3b94e72,
    name: "anzgog___au"
  }, {
    path: "/arthritisnsw",
    component: _e3b94e72,
    name: "arthritisnsw___au"
  }, {
    path: "/arthritissa",
    component: _e3b94e72,
    name: "arthritissa___au"
  }, {
    path: "/aspect",
    component: _e3b94e72,
    name: "aspect___au"
  }, {
    path: "/asrc",
    component: _e3b94e72,
    name: "asrc___au"
  }, {
    path: "/asrc50",
    component: _e3b94e72,
    name: "asrc50___au"
  }, {
    path: "/asthmaaustralia",
    component: _e3b94e72,
    name: "asthmaaustralia___au"
  }, {
    path: "/aurora-123",
    component: _e3b94e72,
    name: "aurora-123___au"
  }, {
    path: "/aussieark",
    component: _e3b94e72,
    name: "aussieark___au"
  }, {
    path: "/autismqld",
    component: _e3b94e72,
    name: "autismqld___au"
  }, {
    path: "/awo",
    component: _e3b94e72,
    name: "awo___au"
  }, {
    path: "/baker",
    component: _e3b94e72,
    name: "baker___au"
  }, {
    path: "/bangarra",
    component: _e3b94e72,
    name: "bangarra___au"
  }, {
    path: "/baptistmissionaustralia",
    component: _e3b94e72,
    name: "baptistmissionaustralia___au"
  }, {
    path: "/barrierreef",
    component: _e3b94e72,
    name: "barrierreef___au"
  }, {
    path: "/birthday-sale",
    component: _4a4d76bd,
    name: "birthday-sale___au"
  }, {
    path: "/black-friday-sale",
    component: _4a4d76bd,
    name: "black-friday-sale___au"
  }, {
    path: "/blog",
    component: _e8ad238a,
    name: "blog___au"
  }, {
    path: "/bluecare",
    component: _e3b94e72,
    name: "bluecare___au"
  }, {
    path: "/blueknot",
    component: _e3b94e72,
    name: "blueknot___au"
  }, {
    path: "/bmf",
    component: _e3b94e72,
    name: "bmf___au"
  }, {
    path: "/bnsw",
    component: _e3b94e72,
    name: "bnsw___au"
  }, {
    path: "/bnsw-staff",
    component: _e3b94e72,
    name: "bnsw-staff___au"
  }, {
    path: "/bobbrown",
    component: _e3b94e72,
    name: "bobbrown___au"
  }, {
    path: "/bowelcanceraustralia",
    component: _e3b94e72,
    name: "bowelcanceraustralia___au"
  }, {
    path: "/breastcanceraus-123",
    component: _e3b94e72,
    name: "breastcanceraus-123___au"
  }, {
    path: "/campquality",
    component: _e3b94e72,
    name: "campquality___au"
  }, {
    path: "/campqualityvolunteers",
    component: _e3b94e72,
    name: "campqualityvolunteers___au"
  }, {
    path: "/cancercouncilnsw",
    component: _e3b94e72,
    name: "cancercouncilnsw___au"
  }, {
    path: "/cancercouncilnswstaff",
    component: _e3b94e72,
    name: "cancercouncilnswstaff___au"
  }, {
    path: "/cancercouncilnswvolunteer",
    component: _e3b94e72,
    name: "cancercouncilnswvolunteer___au"
  }, {
    path: "/cancercouncilwa",
    component: _e3b94e72,
    name: "cancercouncilwa___au"
  }, {
    path: "/cancervic",
    component: _e3b94e72,
    name: "cancervic___au"
  }, {
    path: "/canteen",
    component: _e3b94e72,
    name: "canteen___au"
  }, {
    path: "/cantoo",
    component: _e3b94e72,
    name: "cantoo___au"
  }, {
    path: "/care",
    component: _e3b94e72,
    name: "care___au"
  }, {
    path: "/careers",
    component: _45b2af8f,
    name: "careers___au"
  }, {
    path: "/caritas",
    component: _e3b94e72,
    name: "caritas___au"
  }, {
    path: "/cathaven",
    component: _e3b94e72,
    name: "cathaven___au"
  }, {
    path: "/catherinehouse",
    component: _e3b94e72,
    name: "catherinehouse___au"
  }, {
    path: "/catholiccare",
    component: _e3b94e72,
    name: "catholiccare___au"
  }, {
    path: "/catholiccare-hm-123",
    component: _e3b94e72,
    name: "catholiccare-hm-123___au"
  }, {
    path: "/catholiccarevic",
    component: _e3b94e72,
    name: "catholiccarevic___au"
  }, {
    path: "/catholicmission",
    component: _e3b94e72,
    name: "catholicmission___au"
  }, {
    path: "/catprotection",
    component: _e3b94e72,
    name: "catprotection___au"
  }, {
    path: "/cbrt",
    component: _e3b94e72,
    name: "cbrt___au"
  }, {
    path: "/ccnsw50",
    component: _e3b94e72,
    name: "ccnsw50___au"
  }, {
    path: "/ccnswjune21",
    component: _e3b94e72,
    name: "ccnswjune21___au"
  }, {
    path: "/centenaryinstitute",
    component: _e3b94e72,
    name: "centenaryinstitute___au"
  }, {
    path: "/cerebralpalsy",
    component: _e3b94e72,
    name: "cerebralpalsy___au"
  }, {
    path: "/cfd",
    component: _e3b94e72,
    name: "cfd___au"
  }, {
    path: "/charities",
    component: _63a98eda,
    name: "charities___au"
  }, {
    path: "/charlessturt",
    component: _e3b94e72,
    name: "charlessturt___au"
  }, {
    path: "/charliesfoundation",
    component: _e3b94e72,
    name: "charliesfoundation___au"
  }, {
    path: "/childcancerresearch",
    component: _e3b94e72,
    name: "childcancerresearch___au"
  }, {
    path: "/childhoodcancer",
    component: _e3b94e72,
    name: "childhoodcancer___au"
  }, {
    path: "/cmri",
    component: _e3b94e72,
    name: "cmri___au"
  }, {
    path: "/couple-wills",
    component: _4a4d76bd,
    name: "couple-wills___au"
  }, {
    path: "/cpl",
    component: _e3b94e72,
    name: "cpl___au"
  }, {
    path: "/cyber-monday-sale",
    component: _4a4d76bd,
    name: "cyber-monday-sale___au"
  }, {
    path: "/cysticfibrosiswa",
    component: _e3b94e72,
    name: "cysticfibrosiswa___au"
  }, {
    path: "/deafchildrenaus",
    component: _e3b94e72,
    name: "deafchildrenaus___au"
  }, {
    path: "/deakin",
    component: _e3b94e72,
    name: "deakin___au"
  }, {
    path: "/deakin100",
    component: _e3b94e72,
    name: "deakin100___au"
  }, {
    path: "/diabetesvic",
    component: _e3b94e72,
    name: "diabetesvic___au"
  }, {
    path: "/dsr-123",
    component: _e3b94e72,
    name: "dsr-123___au"
  }, {
    path: "/earthwatch",
    component: _e3b94e72,
    name: "earthwatch___au"
  }, {
    path: "/earthwatchstaff",
    component: _e3b94e72,
    name: "earthwatchstaff___au"
  }, {
    path: "/eofy-sale",
    component: _4a4d76bd,
    name: "eofy-sale___au"
  }, {
    path: "/epc",
    component: _e3b94e72,
    name: "epc___au"
  }, {
    path: "/epc50",
    component: _e3b94e72,
    name: "epc50___au"
  }, {
    path: "/epilepsyfoundation",
    component: _e3b94e72,
    name: "epilepsyfoundation___au"
  }, {
    path: "/equalityaus",
    component: _e3b94e72,
    name: "equalityaus___au"
  }, {
    path: "/fathers-day-sale",
    component: _4a4d76bd,
    name: "fathers-day-sale___au"
  }, {
    path: "/febc",
    component: _e3b94e72,
    name: "febc___au"
  }, {
    path: "/ffv-123",
    component: _e3b94e72,
    name: "ffv-123___au"
  }, {
    path: "/fia",
    component: _e3b94e72,
    name: "fia___au"
  }, {
    path: "/fiftyup",
    component: _83ecbba2,
    name: "fiftyup___au"
  }, {
    path: "/fightmnd",
    component: _e3b94e72,
    name: "fightmnd___au"
  }, {
    path: "/fightparkinsons",
    component: _e3b94e72,
    name: "fightparkinsons___au"
  }, {
    path: "/flash-sale",
    component: _4a4d76bd,
    name: "flash-sale___au"
  }, {
    path: "/fredhollows",
    component: _e3b94e72,
    name: "fredhollows___au"
  }, {
    path: "/free-will-week",
    component: _4a4d76bd,
    name: "free-will-week___au"
  }, {
    path: "/fullstop",
    component: _e3b94e72,
    name: "fullstop___au"
  }, {
    path: "/garvan-123",
    component: _e3b94e72,
    name: "garvan-123___au"
  }, {
    path: "/gaws",
    component: _e3b94e72,
    name: "gaws___au"
  }, {
    path: "/globalinteraction",
    component: _e3b94e72,
    name: "globalinteraction___au"
  }, {
    path: "/greenpeace",
    component: _e3b94e72,
    name: "greenpeace___au"
  }, {
    path: "/greyhoundrescue",
    component: _e3b94e72,
    name: "greyhoundrescue___au"
  }, {
    path: "/growaustralia",
    component: _e3b94e72,
    name: "growaustralia___au"
  }, {
    path: "/guidance-notes",
    component: _c4a9f8bc,
    name: "guidance-notes___au"
  }, {
    path: "/guidedogs",
    component: _e3b94e72,
    name: "guidedogs___au"
  }, {
    path: "/guidedogsqld-123",
    component: _e3b94e72,
    name: "guidedogsqld-123___au"
  }, {
    path: "/guidedogssant",
    component: _e3b94e72,
    name: "guidedogssant___au"
  }, {
    path: "/guidedogstas",
    component: _e3b94e72,
    name: "guidedogstas___au"
  }, {
    path: "/guidedogsvic-123",
    component: _e3b94e72,
    name: "guidedogsvic-123___au"
  }, {
    path: "/guidedogswa",
    component: _e3b94e72,
    name: "guidedogswa___au"
  }, {
    path: "/habitat",
    component: _e3b94e72,
    name: "habitat___au"
  }, {
    path: "/hatzolahmelb-123",
    component: _e3b94e72,
    name: "hatzolahmelb-123___au"
  }, {
    path: "/heartfoundation",
    component: _e3b94e72,
    name: "heartfoundation___au"
  }, {
    path: "/heartkids",
    component: _e3b94e72,
    name: "heartkids___au"
  }, {
    path: "/hopemedia",
    component: _e3b94e72,
    name: "hopemedia___au"
  }, {
    path: "/how-it-works",
    component: _0a0f105a,
    name: "how-it-works___au"
  }, {
    path: "/hudson",
    component: _e3b94e72,
    name: "hudson___au"
  }, {
    path: "/hudsonstaff",
    component: _e3b94e72,
    name: "hudsonstaff___au"
  }, {
    path: "/hutchins",
    component: _e3b94e72,
    name: "hutchins___au"
  }, {
    path: "/i-will-write-my-will",
    component: _4a4d76bd,
    name: "i-will-write-my-will___au"
  }, {
    path: "/ifaw",
    component: _e3b94e72,
    name: "ifaw___au"
  }, {
    path: "/ina",
    component: _e3b94e72,
    name: "ina___au"
  }, {
    path: "/includeacharity",
    component: _e3b94e72,
    name: "includeacharity___au"
  }, {
    path: "/infantshome",
    component: _e3b94e72,
    name: "infantshome___au"
  }, {
    path: "/integrity",
    component: _e3b94e72,
    name: "integrity___au"
  }, {
    path: "/iwc",
    component: _e3b94e72,
    name: "iwc___au"
  }, {
    path: "/iwc-supporters",
    component: _e3b94e72,
    name: "iwc-supporters___au"
  }, {
    path: "/iwda-123",
    component: _e3b94e72,
    name: "iwda-123___au"
  }, {
    path: "/jnf",
    component: _e3b94e72,
    name: "jnf___au"
  }, {
    path: "/kcrt-123",
    component: _e3b94e72,
    name: "kcrt-123___au"
  }, {
    path: "/kidneyhealth",
    component: _e3b94e72,
    name: "kidneyhealth___au"
  }, {
    path: "/kidshelpline",
    component: _e3b94e72,
    name: "kidshelpline___au"
  }, {
    path: "/legal-advice",
    component: _acde9cbc,
    name: "legal-advice___au"
  }, {
    path: "/lei",
    component: _e3b94e72,
    name: "lei___au"
  }, {
    path: "/leprosymission",
    component: _e3b94e72,
    name: "leprosymission___au"
  }, {
    path: "/leukaemiafoundation",
    component: _e3b94e72,
    name: "leukaemiafoundation___au"
  }, {
    path: "/lifeed",
    component: _e3b94e72,
    name: "lifeed___au"
  }, {
    path: "/lifelineaus",
    component: _e3b94e72,
    name: "lifelineaus___au"
  }, {
    path: "/lifelinedirect",
    component: _e3b94e72,
    name: "lifelinedirect___au"
  }, {
    path: "/lifelineqld",
    component: _e3b94e72,
    name: "lifelineqld___au"
  }, {
    path: "/lungfoundation",
    component: _e3b94e72,
    name: "lungfoundation___au"
  }, {
    path: "/mater",
    component: _e3b94e72,
    name: "mater___au"
  }, {
    path: "/megavoice",
    component: _e3b94e72,
    name: "megavoice___au"
  }, {
    path: "/mercyships",
    component: _e3b94e72,
    name: "mercyships___au"
  }, {
    path: "/missionaustralia",
    component: _e3b94e72,
    name: "missionaustralia___au"
  }, {
    path: "/monash",
    component: _e3b94e72,
    name: "monash___au"
  }, {
    path: "/mothers-day-sale",
    component: _4a4d76bd,
    name: "mothers-day-sale___au"
  }, {
    path: "/mowsa",
    component: _e3b94e72,
    name: "mowsa___au"
  }, {
    path: "/msfa",
    component: _e3b94e72,
    name: "msfa___au"
  }, {
    path: "/msiasiapacific",
    component: _e3b94e72,
    name: "msiasiapacific___au"
  }, {
    path: "/mswa",
    component: _e3b94e72,
    name: "mswa___au"
  }, {
    path: "/mwb",
    component: _e3b94e72,
    name: "mwb___au"
  }, {
    path: "/mwf",
    component: _e3b94e72,
    name: "mwf___au"
  }, {
    path: "/nab-123",
    component: _e3b94e72,
    name: "nab-123___au"
  }, {
    path: "/nationaltrustnsw",
    component: _e3b94e72,
    name: "nationaltrustnsw___au"
  }, {
    path: "/nationaltrustwa",
    component: _e3b94e72,
    name: "nationaltrustwa___au"
  }, {
    path: "/nationaltrustwa-members",
    component: _e3b94e72,
    name: "nationaltrustwa-members___au"
  }, {
    path: "/ncf",
    component: _e3b94e72,
    name: "ncf___au"
  }, {
    path: "/new-financial-year-sale",
    component: _4a4d76bd,
    name: "new-financial-year-sale___au"
  }, {
    path: "/new-year-sale",
    component: _4a4d76bd,
    name: "new-year-sale___au"
  }, {
    path: "/newsletter",
    component: _7683accf,
    name: "newsletter___au"
  }, {
    path: "/nextsense",
    component: _e3b94e72,
    name: "nextsense___au"
  }, {
    path: "/nswliberal",
    component: _e3b94e72,
    name: "nswliberal___au"
  }, {
    path: "/onebigswitch",
    component: _83ecbba2,
    name: "onebigswitch___au"
  }, {
    path: "/onepercent",
    component: _e3b94e72,
    name: "onepercent___au"
  }, {
    path: "/operationsmile",
    component: _e3b94e72,
    name: "operationsmile___au"
  }, {
    path: "/orangesky",
    component: _e3b94e72,
    name: "orangesky___au"
  }, {
    path: "/oxfam",
    component: _e3b94e72,
    name: "oxfam___au"
  }, {
    path: "/ozchild",
    component: _e3b94e72,
    name: "ozchild___au"
  }, {
    path: "/paralympicsaus",
    component: _e3b94e72,
    name: "paralympicsaus___au"
  }, {
    path: "/pcycnsw",
    component: _e3b94e72,
    name: "pcycnsw___au"
  }, {
    path: "/petwelfare",
    component: _e3b94e72,
    name: "petwelfare___au"
  }, {
    path: "/planinternational",
    component: _e3b94e72,
    name: "planinternational___au"
  }, {
    path: "/power-of-attorney",
    component: _38e49a26,
    name: "power-of-attorney___au"
  }, {
    path: "/powers-of-attorney-nsw",
    component: _4a4d76bd,
    name: "powers-of-attorney-nsw___au"
  }, {
    path: "/powers-of-attorney-qld",
    component: _4a4d76bd,
    name: "powers-of-attorney-qld___au"
  }, {
    path: "/powers-of-attorney-victoria",
    component: _4a4d76bd,
    name: "powers-of-attorney-victoria___au"
  }, {
    path: "/powers-of-attorney-wa",
    component: _4a4d76bd,
    name: "powers-of-attorney-wa___au"
  }, {
    path: "/pricing",
    component: _57bb13c0,
    name: "pricing___au"
  }, {
    path: "/privacy",
    component: _5e416e3c,
    name: "privacy___au"
  }, {
    path: "/rawcs",
    component: _e3b94e72,
    name: "rawcs___au"
  }, {
    path: "/rchfoundation",
    component: _e3b94e72,
    name: "rchfoundation___au"
  }, {
    path: "/redcross",
    component: _e3b94e72,
    name: "redcross___au"
  }, {
    path: "/redr",
    component: _e3b94e72,
    name: "redr___au"
  }, {
    path: "/rlsswa",
    component: _e3b94e72,
    name: "rlsswa___au"
  }, {
    path: "/rotaryfoundation",
    component: _e3b94e72,
    name: "rotaryfoundation___au"
  }, {
    path: "/royalfarwest",
    component: _e3b94e72,
    name: "royalfarwest___au"
  }, {
    path: "/royalwomen",
    component: _e3b94e72,
    name: "royalwomen___au"
  }, {
    path: "/rphresearch",
    component: _e3b94e72,
    name: "rphresearch___au"
  }, {
    path: "/RSPCA",
    component: _e3b94e72,
    name: "RSPCA___au"
  }, {
    path: "/safesteps",
    component: _e3b94e72,
    name: "safesteps___au"
  }, {
    path: "/safewill-legal-terms",
    component: _1d8b2a1b,
    name: "safewill-legal-terms___au"
  }, {
    path: "/salvationarmy",
    component: _e3b94e72,
    name: "salvationarmy___au"
  }, {
    path: "/savethechildren",
    component: _e3b94e72,
    name: "savethechildren___au"
  }, {
    path: "/schoolforlife",
    component: _e3b94e72,
    name: "schoolforlife___au"
  }, {
    path: "/security",
    component: _b9542954,
    name: "security___au"
  }, {
    path: "/SLSF",
    component: _e3b94e72,
    name: "SLSF___au"
  }, {
    path: "/slswa",
    component: _e3b94e72,
    name: "slswa___au"
  }, {
    path: "/smhow",
    component: _e3b94e72,
    name: "smhow___au"
  }, {
    path: "/sonshine-123",
    component: _e3b94e72,
    name: "sonshine-123___au"
  }, {
    path: "/sportingwheelies",
    component: _e3b94e72,
    name: "sportingwheelies___au"
  }, {
    path: "/standrewswmh",
    component: _e3b94e72,
    name: "standrewswmh___au"
  }, {
    path: "/steppingstonehouse",
    component: _e3b94e72,
    name: "steppingstonehouse___au"
  }, {
    path: "/stevewaugh",
    component: _e3b94e72,
    name: "stevewaugh___au"
  }, {
    path: "/stjohnwa",
    component: _e3b94e72,
    name: "stjohnwa___au"
  }, {
    path: "/strokefoundation",
    component: _e3b94e72,
    name: "strokefoundation___au"
  }, {
    path: "/sunsw",
    component: _e3b94e72,
    name: "sunsw___au"
  }, {
    path: "/svcf",
    component: _e3b94e72,
    name: "svcf___au"
  }, {
    path: "/svdpvic",
    component: _e3b94e72,
    name: "svdpvic___au"
  }, {
    path: "/svdpvic50",
    component: _e3b94e72,
    name: "svdpvic50___au"
  }, {
    path: "/SVDPWA",
    component: _e3b94e72,
    name: "SVDPWA___au"
  }, {
    path: "/svh",
    component: _e3b94e72,
    name: "svh___au"
  }, {
    path: "/swans",
    component: _e3b94e72,
    name: "swans___au"
  }, {
    path: "/swt-123",
    component: _e3b94e72,
    name: "swt-123___au"
  }, {
    path: "/terms",
    component: _5df21fe1,
    name: "terms___au"
  }, {
    path: "/theaustraliainstitute",
    component: _e3b94e72,
    name: "theaustraliainstitute___au"
  }, {
    path: "/theconversation",
    component: _e3b94e72,
    name: "theconversation___au"
  }, {
    path: "/thelifeyoucansave",
    component: _e3b94e72,
    name: "thelifeyoucansave___au"
  }, {
    path: "/theshepherdcentre",
    component: _e3b94e72,
    name: "theshepherdcentre___au"
  }, {
    path: "/thewesleyhospital",
    component: _e3b94e72,
    name: "thewesleyhospital___au"
  }, {
    path: "/thrfg",
    component: _e3b94e72,
    name: "thrfg___au"
  }, {
    path: "/uni-newcastle",
    component: _e3b94e72,
    name: "uni-newcastle___au"
  }, {
    path: "/unicef",
    component: _e3b94e72,
    name: "unicef___au"
  }, {
    path: "/unitingcareqld",
    component: _e3b94e72,
    name: "unitingcareqld___au"
  }, {
    path: "/usyd",
    component: _e3b94e72,
    name: "usyd___au"
  }, {
    path: "/v-day-love",
    component: _4a4d76bd,
    name: "v-day-love___au"
  }, {
    path: "/varietywa",
    component: _e3b94e72,
    name: "varietywa___au"
  }, {
    path: "/vault",
    component: _f7fb89e8,
    name: "vault___au"
  }, {
    path: "/victorchang",
    component: _e3b94e72,
    name: "victorchang___au"
  }, {
    path: "/vinnies-nsw-123",
    component: _e3b94e72,
    name: "vinnies-nsw-123___au"
  }, {
    path: "/vinniesact-surrounds",
    component: _e3b94e72,
    name: "vinniesact-surrounds___au"
  }, {
    path: "/vinniesnsw",
    component: _e3b94e72,
    name: "vinniesnsw___au"
  }, {
    path: "/vsk",
    component: _e3b94e72,
    name: "vsk___au"
  }, {
    path: "/vu",
    component: _e3b94e72,
    name: "vu___au"
  }, {
    path: "/welcome-back",
    component: _236ef488,
    name: "welcome-back___au"
  }, {
    path: "/wellways",
    component: _e3b94e72,
    name: "wellways___au"
  }, {
    path: "/wilderness",
    component: _e3b94e72,
    name: "wilderness___au"
  }, {
    path: "/wildernessaus",
    component: _e3b94e72,
    name: "wildernessaus___au"
  }, {
    path: "/wildlifevictoria",
    component: _e3b94e72,
    name: "wildlifevictoria___au"
  }, {
    path: "/wills",
    component: _7b29e43b,
    name: "wills___au"
  }, {
    path: "/wills-nsw",
    component: _4a4d76bd,
    name: "wills-nsw___au"
  }, {
    path: "/wills-qld",
    component: _4a4d76bd,
    name: "wills-qld___au"
  }, {
    path: "/wills-victoria",
    component: _4a4d76bd,
    name: "wills-victoria___au"
  }, {
    path: "/wizoaus",
    component: _e3b94e72,
    name: "wizoaus___au"
  }, {
    path: "/wizovic",
    component: _e3b94e72,
    name: "wizovic___au"
  }, {
    path: "/worldshare",
    component: _e3b94e72,
    name: "worldshare___au"
  }, {
    path: "/wwf",
    component: _e3b94e72,
    name: "wwf___au"
  }, {
    path: "/xmas-grinch-sale",
    component: _4a4d76bd,
    name: "xmas-grinch-sale___au"
  }, {
    path: "/xmas-sale",
    component: _4a4d76bd,
    name: "xmas-sale___au"
  }, {
    path: "/yancoalintegrity-123",
    component: _e3b94e72,
    name: "yancoalintegrity-123___au"
  }, {
    path: "/youngcare",
    component: _e3b94e72,
    name: "youngcare___au"
  }, {
    path: "/yourtown",
    component: _e3b94e72,
    name: "yourtown___au"
  }, {
    path: "/ywca",
    component: _e3b94e72,
    name: "ywca___au"
  }, {
    path: "/blog/guides",
    component: _72d87a61,
    name: "blog-guides___au"
  }, {
    path: "/blog/posts",
    component: _76b7623f,
    name: "blog-posts___au"
  }, {
    path: "/charities/directory",
    component: _7b16d831,
    name: "charities-directory___au"
  }, {
    path: "/blog/posts/10-reasons-why-you-need-a-will",
    component: _7500c0f7,
    name: "10-reasons-why-you-need-a-will___au"
  }, {
    path: "/blog/posts/11-reasons-you-should-choose-safewill",
    component: _7500c0f7,
    name: "11-reasons-you-should-choose-safewill___au"
  }, {
    path: "/blog/posts/3-ways-to-save-on-funeral-costs",
    component: _7500c0f7,
    name: "3-ways-to-save-on-funeral-costs___au"
  }, {
    path: "/blog/posts/4-actionable-tips-for-an-eco-friendly-funeral",
    component: _7500c0f7,
    name: "4-actionable-tips-for-an-eco-friendly-funeral___au"
  }, {
    path: "/blog/posts/4-alternative-condolence-gifts-to-flowers",
    component: _7500c0f7,
    name: "4-alternative-condolence-gifts-to-flowers___au"
  }, {
    path: "/blog/posts/5-benefits-of-writing-your-will-young",
    component: _7500c0f7,
    name: "5-benefits-of-writing-your-will-young___au"
  }, {
    path: "/blog/posts/5-considerations-for-the-perfect-urn-choice",
    component: _7500c0f7,
    name: "5-considerations-for-the-perfect-urn-choice___au"
  }, {
    path: "/blog/posts/5-different-cultural-approaches-to-death",
    component: _7500c0f7,
    name: "5-different-cultural-approaches-to-death___au"
  }, {
    path: "/blog/posts/5-distinguishing-benefits-of-digital-vs-traditional-wills",
    component: _7500c0f7,
    name: "5-distinguishing-benefits-of-digital-vs-traditional-wills___au"
  }, {
    path: "/blog/posts/5-life-altering-takeaways-from-the-top-ted-talks-on-death",
    component: _7500c0f7,
    name: "5-life-altering-takeaways-from-the-top-ted-talks-on-death___au"
  }, {
    path: "/blog/posts/5-meaningful-funeral-quotes-about-death",
    component: _7500c0f7,
    name: "5-meaningful-funeral-quotes-about-death___au"
  }, {
    path: "/blog/posts/5-scientific-rules-for-making-breaking-goals-in-2023",
    component: _7500c0f7,
    name: "5-scientific-rules-for-making-breaking-goals-in-2023___au"
  }, {
    path: "/blog/posts/5-surprising-celebrities-who-died-without-a-will",
    component: _7500c0f7,
    name: "5-surprising-celebrities-who-died-without-a-will___au"
  }, {
    path: "/blog/posts/5-tips-to-safeguard-your-mental-health-against-stress",
    component: _7500c0f7,
    name: "5-tips-to-safeguard-your-mental-health-against-stress___au"
  }, {
    path: "/blog/posts/6-easy-health-hacks-for-a-longer-life",
    component: _7500c0f7,
    name: "6-easy-health-hacks-for-a-longer-life___au"
  }, {
    path: "/blog/posts/6-ways-to-handle-your-estate",
    component: _7500c0f7,
    name: "6-ways-to-handle-your-estate___au"
  }, {
    path: "/blog/posts/a-guide-to-sydneys-cemeteries-in-2022",
    component: _7500c0f7,
    name: "a-guide-to-sydneys-cemeteries-in-2022___au"
  }, {
    path: "/blog/posts/advance-care-directive",
    component: _7500c0f7,
    name: "advance-care-directive___au"
  }, {
    path: "/blog/posts/advanced-healthcare-directives-matter-for-you-heres-why",
    component: _7500c0f7,
    name: "advanced-healthcare-directives-matter-for-you-heres-why___au"
  }, {
    path: "/blog/posts/another-year-gone-reflecting-on-how-we-used-our-time-in-2022",
    component: _7500c0f7,
    name: "another-year-gone-reflecting-on-how-we-used-our-time-in-2022___au"
  }, {
    path: "/blog/posts/appointing-a-legal-guardian-for-your-children",
    component: _7500c0f7,
    name: "appointing-a-legal-guardian-for-your-children___au"
  }, {
    path: "/blog/posts/are-online-wills-legal",
    component: _7500c0f7,
    name: "are-online-wills-legal___au"
  }, {
    path: "/blog/posts/avoid-these-5-death-faux-pas-when-supporting-a-grieving-friend",
    component: _7500c0f7,
    name: "avoid-these-5-death-faux-pas-when-supporting-a-grieving-friend___au"
  }, {
    path: "/blog/posts/avoid-these-top-10-probate-myths",
    component: _7500c0f7,
    name: "avoid-these-top-10-probate-myths___au"
  }, {
    path: "/blog/posts/becoming-widowed",
    component: _7500c0f7,
    name: "becoming-widowed___au"
  }, {
    path: "/blog/posts/benefits--a-digital-will",
    component: _7500c0f7,
    name: "benefits--a-digital-will___au"
  }, {
    path: "/blog/posts/benefits-of-a-direct-cremation",
    component: _7500c0f7,
    name: "benefits-of-a-direct-cremation___au"
  }, {
    path: "/blog/posts/can-we-have-a-tough-conversation",
    component: _7500c0f7,
    name: "can-we-have-a-tough-conversation___au"
  }, {
    path: "/blog/posts/can-you-contest-a-will-after-probate",
    component: _7500c0f7,
    name: "can-you-contest-a-will-after-probate___au"
  }, {
    path: "/blog/posts/can-you-prevent-dementia",
    component: _7500c0f7,
    name: "can-you-prevent-dementia___au"
  }, {
    path: "/blog/posts/charitable-gifts-in-wills",
    component: _7500c0f7,
    name: "charitable-gifts-in-wills___au"
  }, {
    path: "/blog/posts/checklist-for-writing-your-will",
    component: _7500c0f7,
    name: "checklist-for-writing-your-will___au"
  }, {
    path: "/blog/posts/choosing-between-a-professional-or-personal-executor-of-will",
    component: _7500c0f7,
    name: "choosing-between-a-professional-or-personal-executor-of-will___au"
  }, {
    path: "/blog/posts/choosing-flowers-for-a-funeral",
    component: _7500c0f7,
    name: "choosing-flowers-for-a-funeral___au"
  }, {
    path: "/blog/posts/compassionate-leave-in-australia",
    component: _7500c0f7,
    name: "compassionate-leave-in-australia___au"
  }, {
    path: "/blog/posts/complete-checklist-for-when-someone-dies",
    component: _7500c0f7,
    name: "complete-checklist-for-when-someone-dies___au"
  }, {
    path: "/blog/posts/contested-wills-why-when-how-to-deal-if-this-happens",
    component: _7500c0f7,
    name: "contested-wills-why-when-how-to-deal-if-this-happens___au"
  }, {
    path: "/blog/posts/creating-a-retirement-plan",
    component: _7500c0f7,
    name: "creating-a-retirement-plan___au"
  }, {
    path: "/blog/posts/cremation",
    component: _7500c0f7,
    name: "cremation___au"
  }, {
    path: "/blog/posts/death-doulas-the-all-rounder-for-end-of-life-care",
    component: _7500c0f7,
    name: "death-doulas-the-all-rounder-for-end-of-life-care___au"
  }, {
    path: "/blog/posts/debunking-harmful-organ-donation-myths",
    component: _7500c0f7,
    name: "debunking-harmful-organ-donation-myths___au"
  }, {
    path: "/blog/posts/debunking-the-top-10-cremation-myths",
    component: _7500c0f7,
    name: "debunking-the-top-10-cremation-myths___au"
  }, {
    path: "/blog/posts/do-you-have-all-the-required-info-for-an-online-will",
    component: _7500c0f7,
    name: "do-you-have-all-the-required-info-for-an-online-will___au"
  }, {
    path: "/blog/posts/embalming-in-australia",
    component: _7500c0f7,
    name: "embalming-in-australia___au"
  }, {
    path: "/blog/posts/end-of-life-planning",
    component: _7500c0f7,
    name: "end-of-life-planning___au"
  }, {
    path: "/blog/posts/estate-administration",
    component: _7500c0f7,
    name: "estate-administration___au"
  }, {
    path: "/blog/posts/estate-planning-in-australia",
    component: _7500c0f7,
    name: "estate-planning-in-australia___au"
  }, {
    path: "/blog/posts/estate-planning-lawyer",
    component: _7500c0f7,
    name: "estate-planning-lawyer___au"
  }, {
    path: "/blog/posts/everything-you-need-to-know-about-bereavement",
    component: _7500c0f7,
    name: "everything-you-need-to-know-about-bereavement___au"
  }, {
    path: "/blog/posts/everything-you-need-to-know-about-funeral-insurance",
    component: _7500c0f7,
    name: "everything-you-need-to-know-about-funeral-insurance___au"
  }, {
    path: "/blog/posts/everything-you-need-to-know-about-wills",
    component: _7500c0f7,
    name: "everything-you-need-to-know-about-wills___au"
  }, {
    path: "/blog/posts/executor-of-will-duties",
    component: _7500c0f7,
    name: "executor-of-will-duties___au"
  }, {
    path: "/blog/posts/financial-power-of-attorney",
    component: _7500c0f7,
    name: "financial-power-of-attorney___au"
  }, {
    path: "/blog/posts/finding-australian-death-funeral-notices-online",
    component: _7500c0f7,
    name: "finding-australian-death-funeral-notices-online___au"
  }, {
    path: "/blog/posts/funeral-costs-in-australia",
    component: _7500c0f7,
    name: "funeral-costs-in-australia___au"
  }, {
    path: "/blog/posts/funeral-etiquette-the-unspoken-need-to-knows",
    component: _7500c0f7,
    name: "funeral-etiquette-the-unspoken-need-to-knows___au"
  }, {
    path: "/blog/posts/funeral-songs",
    component: _7500c0f7,
    name: "funeral-songs___au"
  }, {
    path: "/blog/posts/grief-support-australia",
    component: _7500c0f7,
    name: "grief-support-australia___au"
  }, {
    path: "/blog/posts/guide-to-wills-everything-you-need-to-know-about-writing-a-will",
    component: _7500c0f7,
    name: "guide-to-wills-everything-you-need-to-know-about-writing-a-will___au"
  }, {
    path: "/blog/posts/healing-from-loss-honouring-loved-ones-in-the-holidays",
    component: _7500c0f7,
    name: "healing-from-loss-honouring-loved-ones-in-the-holidays___au"
  }, {
    path: "/blog/posts/how-do-i-choose-a-guardian",
    component: _7500c0f7,
    name: "how-do-i-choose-a-guardian___au"
  }, {
    path: "/blog/posts/how-do-i-know-if-probate-has-been-granted",
    component: _7500c0f7,
    name: "how-do-i-know-if-probate-has-been-granted___au"
  }, {
    path: "/blog/posts/how-do-i-sign-my-will",
    component: _7500c0f7,
    name: "how-do-i-sign-my-will___au"
  }, {
    path: "/blog/posts/how-easy-is-it-to-make-my-will-online",
    component: _7500c0f7,
    name: "how-easy-is-it-to-make-my-will-online___au"
  }, {
    path: "/blog/posts/how-her-brothers-death-influenced-maryams-work-at-safewill",
    component: _7500c0f7,
    name: "how-her-brothers-death-influenced-maryams-work-at-safewill___au"
  }, {
    path: "/blog/posts/how-intestacy-works-in-australia",
    component: _7500c0f7,
    name: "how-intestacy-works-in-australia___au"
  }, {
    path: "/blog/posts/how-long-does-it-take-to-get-a-grant-of-probate-or-letters-of-administration",
    component: _7500c0f7,
    name: "how-long-does-it-take-to-get-a-grant-of-probate-or-letters-of-administration___au"
  }, {
    path: "/blog/posts/how-much-does-a-will-cost-in-australia",
    component: _7500c0f7,
    name: "how-much-does-a-will-cost-in-australia___au"
  }, {
    path: "/blog/posts/how-much-does-an-australian-funeral-really-cost",
    component: _7500c0f7,
    name: "how-much-does-an-australian-funeral-really-cost___au"
  }, {
    path: "/blog/posts/how-power-of-attorney-differs-by-state-victoria-vs-wa",
    component: _7500c0f7,
    name: "how-power-of-attorney-differs-by-state-victoria-vs-wa___au"
  }, {
    path: "/blog/posts/how-property-ownership-affects-your-will",
    component: _7500c0f7,
    name: "how-property-ownership-affects-your-will___au"
  }, {
    path: "/blog/posts/how-technology-is-changing-end-of-life-planning",
    component: _7500c0f7,
    name: "how-technology-is-changing-end-of-life-planning___au"
  }, {
    path: "/blog/posts/how-to-appoint-your-power-of-attorney-in-nsw",
    component: _7500c0f7,
    name: "how-to-appoint-your-power-of-attorney-in-nsw___au"
  }, {
    path: "/blog/posts/how-to-become-an-organ-donor-in-australia",
    component: _7500c0f7,
    name: "how-to-become-an-organ-donor-in-australia___au"
  }, {
    path: "/blog/posts/how-to-build-generational-wealth",
    component: _7500c0f7,
    name: "how-to-build-generational-wealth___au"
  }, {
    path: "/blog/posts/how-to-care-for-your-pet-when-you-die",
    component: _7500c0f7,
    name: "how-to-care-for-your-pet-when-you-die___au"
  }, {
    path: "/blog/posts/how-to-choose-a-coffin",
    component: _7500c0f7,
    name: "how-to-choose-a-coffin___au"
  }, {
    path: "/blog/posts/how-to-choose-the-right-funeral-director-a-comprehensive-guide",
    component: _7500c0f7,
    name: "how-to-choose-the-right-funeral-director-a-comprehensive-guide___au"
  }, {
    path: "/blog/posts/how-to-choose-the-right-funeral-flowers",
    component: _7500c0f7,
    name: "how-to-choose-the-right-funeral-flowers___au"
  }, {
    path: "/blog/posts/how-to-cope-when-facing-death",
    component: _7500c0f7,
    name: "how-to-cope-when-facing-death___au"
  }, {
    path: "/blog/posts/how-to-create-a-comprehensive-estate-plan-with-corporate-structures-and-wills",
    component: _7500c0f7,
    name: "how-to-create-a-comprehensive-estate-plan-with-corporate-structures-and-wills___au"
  }, {
    path: "/blog/posts/how-to-decide-between-open-or-closed-casket-funeral",
    component: _7500c0f7,
    name: "how-to-decide-between-open-or-closed-casket-funeral___au"
  }, {
    path: "/blog/posts/how-to-easily-include-a-charity-in-your-will",
    component: _7500c0f7,
    name: "how-to-easily-include-a-charity-in-your-will___au"
  }, {
    path: "/blog/posts/how-to-find-a-will",
    component: _7500c0f7,
    name: "how-to-find-a-will___au"
  }, {
    path: "/blog/posts/how-to-get-a-death-certificate",
    component: _7500c0f7,
    name: "how-to-get-a-death-certificate___au"
  }, {
    path: "/blog/posts/how-to-memorialise-your-loved-ones",
    component: _7500c0f7,
    name: "how-to-memorialise-your-loved-ones___au"
  }, {
    path: "/blog/posts/how-to-plan-a-funeral",
    component: _7500c0f7,
    name: "how-to-plan-a-funeral___au"
  }, {
    path: "/blog/posts/how-to-plan-a-meaningful-direct-cremation-a-guide-for-families",
    component: _7500c0f7,
    name: "how-to-plan-a-meaningful-direct-cremation-a-guide-for-families___au"
  }, {
    path: "/blog/posts/how-to-plan-an-internment-of-ashes-ceremony",
    component: _7500c0f7,
    name: "how-to-plan-an-internment-of-ashes-ceremony___au"
  }, {
    path: "/blog/posts/how-to-plan-your-estate-with-foreign-assets",
    component: _7500c0f7,
    name: "how-to-plan-your-estate-with-foreign-assets___au"
  }, {
    path: "/blog/posts/how-to-redirect-mail-through-australia-post",
    component: _7500c0f7,
    name: "how-to-redirect-mail-through-australia-post___au"
  }, {
    path: "/blog/posts/how-to-set-up-a-discretionary-trust",
    component: _7500c0f7,
    name: "how-to-set-up-a-discretionary-trust___au"
  }, {
    path: "/blog/posts/how-to-set-up-a-prepaid-funeral-australia",
    component: _7500c0f7,
    name: "how-to-set-up-a-prepaid-funeral-australia___au"
  }, {
    path: "/blog/posts/how-to-set-up-a-trust-account-in-australia",
    component: _7500c0f7,
    name: "how-to-set-up-a-trust-account-in-australia___au"
  }, {
    path: "/blog/posts/how-to-set-up-a-trust-fund",
    component: _7500c0f7,
    name: "how-to-set-up-a-trust-fund___au"
  }, {
    path: "/blog/posts/how-to-support-someone-who-is-dying",
    component: _7500c0f7,
    name: "how-to-support-someone-who-is-dying___au"
  }, {
    path: "/blog/posts/how-to-talk-about-a-loved-ones-death",
    component: _7500c0f7,
    name: "how-to-talk-about-a-loved-ones-death___au"
  }, {
    path: "/blog/posts/how-to-write-a-condolence-message",
    component: _7500c0f7,
    name: "how-to-write-a-condolence-message___au"
  }, {
    path: "/blog/posts/how-to-write-a-eulogy",
    component: _7500c0f7,
    name: "how-to-write-a-eulogy___au"
  }, {
    path: "/blog/posts/how-to-write-a-will-for-your-blended-family",
    component: _7500c0f7,
    name: "how-to-write-a-will-for-your-blended-family___au"
  }, {
    path: "/blog/posts/how-to-write-an-obituary",
    component: _7500c0f7,
    name: "how-to-write-an-obituary___au"
  }, {
    path: "/blog/posts/how-you-could-benefit-from-a-family-trust",
    component: _7500c0f7,
    name: "how-you-could-benefit-from-a-family-trust___au"
  }, {
    path: "/blog/posts/industry-update-online-wills-in-the-law",
    component: _7500c0f7,
    name: "industry-update-online-wills-in-the-law___au"
  }, {
    path: "/blog/posts/informal-wills",
    component: _7500c0f7,
    name: "informal-wills___au"
  }, {
    path: "/blog/posts/inheritance-rights-in-australia-do-spouses-automatically-inherit-everything",
    component: _7500c0f7,
    name: "inheritance-rights-in-australia-do-spouses-automatically-inherit-everything___au"
  }, {
    path: "/blog/posts/inheritance-tax-australia",
    component: _7500c0f7,
    name: "inheritance-tax-australia___au"
  }, {
    path: "/blog/posts/intestacy-in-australia",
    component: _7500c0f7,
    name: "intestacy-in-australia___au"
  }, {
    path: "/blog/posts/is-it-possible-to-contest-a-will",
    component: _7500c0f7,
    name: "is-it-possible-to-contest-a-will___au"
  }, {
    path: "/blog/posts/last-will-testament-what-it-is-why-its-important",
    component: _7500c0f7,
    name: "last-will-testament-what-it-is-why-its-important___au"
  }, {
    path: "/blog/posts/learn-from-these-top-5-deathbed-regrets",
    component: _7500c0f7,
    name: "learn-from-these-top-5-deathbed-regrets___au"
  }, {
    path: "/blog/posts/letters-of-administration",
    component: _7500c0f7,
    name: "letters-of-administration___au"
  }, {
    path: "/blog/posts/letters-of-administration-nsw",
    component: _7500c0f7,
    name: "letters-of-administration-nsw___au"
  }, {
    path: "/blog/posts/listen-to-these-5-podcasts-if-your-grieving",
    component: _7500c0f7,
    name: "listen-to-these-5-podcasts-if-your-grieving___au"
  }, {
    path: "/blog/posts/maryams-son-was-stillborn-heres-her-advice-to-support-grieving-people",
    component: _7500c0f7,
    name: "maryams-son-was-stillborn-heres-her-advice-to-support-grieving-people___au"
  }, {
    path: "/blog/posts/medical-power-of-attorney",
    component: _7500c0f7,
    name: "medical-power-of-attorney___au"
  }, {
    path: "/blog/posts/memento-mori",
    component: _7500c0f7,
    name: "memento-mori___au"
  }, {
    path: "/blog/posts/millennials-am-i-too-young-to-write-a-will",
    component: _7500c0f7,
    name: "millennials-am-i-too-young-to-write-a-will___au"
  }, {
    path: "/blog/posts/palliative-care-and-end-of-life-care",
    component: _7500c0f7,
    name: "palliative-care-and-end-of-life-care___au"
  }, {
    path: "/blog/posts/planning-a-celebration-of-life",
    component: _7500c0f7,
    name: "planning-a-celebration-of-life___au"
  }, {
    path: "/blog/posts/planning-a-cremation-in-sydney",
    component: _7500c0f7,
    name: "planning-a-cremation-in-sydney___au"
  }, {
    path: "/blog/posts/poems-for-funerals",
    component: _7500c0f7,
    name: "poems-for-funerals___au"
  }, {
    path: "/blog/posts/power-of-attorney-in-queensland",
    component: _7500c0f7,
    name: "power-of-attorney-in-queensland___au"
  }, {
    path: "/blog/posts/prenup-in-australia-everything-you-need-to-know-in-2023",
    component: _7500c0f7,
    name: "prenup-in-australia-everything-you-need-to-know-in-2023___au"
  }, {
    path: "/blog/posts/probate-in-nsw",
    component: _7500c0f7,
    name: "probate-in-nsw___au"
  }, {
    path: "/blog/posts/probate-queensland",
    component: _7500c0f7,
    name: "probate-queensland___au"
  }, {
    path: "/blog/posts/probate-victoria",
    component: _7500c0f7,
    name: "probate-victoria___au"
  }, {
    path: "/blog/posts/probate-what-is-it-and-how-does-the-process-work",
    component: _7500c0f7,
    name: "probate-what-is-it-and-how-does-the-process-work___au"
  }, {
    path: "/blog/posts/public-trustees-in-australia",
    component: _7500c0f7,
    name: "public-trustees-in-australia___au"
  }, {
    path: "/blog/posts/public-vs-private-trusts-whats-the-difference",
    component: _7500c0f7,
    name: "public-vs-private-trusts-whats-the-difference___au"
  }, {
    path: "/blog/posts/resealing-probate",
    component: _7500c0f7,
    name: "resealing-probate___au"
  }, {
    path: "/blog/posts/scattering-ashes",
    component: _7500c0f7,
    name: "scattering-ashes___au"
  }, {
    path: "/blog/posts/scattering-cremation-ashes-with-the-environment-and-the-law-in-mind",
    component: _7500c0f7,
    name: "scattering-cremation-ashes-with-the-environment-and-the-law-in-mind___au"
  }, {
    path: "/blog/posts/should-i-witness-a-will",
    component: _7500c0f7,
    name: "should-i-witness-a-will___au"
  }, {
    path: "/blog/posts/simplifying-deceased-estate-property-transfers-with-pexa",
    component: _7500c0f7,
    name: "simplifying-deceased-estate-property-transfers-with-pexa___au"
  }, {
    path: "/blog/posts/supporting-your-work-bestie-through-grief",
    component: _7500c0f7,
    name: "supporting-your-work-bestie-through-grief___au"
  }, {
    path: "/blog/posts/testamentary-capacity",
    component: _7500c0f7,
    name: "testamentary-capacity___au"
  }, {
    path: "/blog/posts/the-5-benefits-of-prepaid-pet-cremations",
    component: _7500c0f7,
    name: "the-5-benefits-of-prepaid-pet-cremations___au"
  }, {
    path: "/blog/posts/the-consequences-of-dying-without-a-will",
    component: _7500c0f7,
    name: "the-consequences-of-dying-without-a-will___au"
  }, {
    path: "/blog/posts/the-cost-of-writing-your-will-with-a-lawyer",
    component: _7500c0f7,
    name: "the-cost-of-writing-your-will-with-a-lawyer___au"
  }, {
    path: "/blog/posts/the-difference-between-a-diy-will-kit-and-an-online-will",
    component: _7500c0f7,
    name: "the-difference-between-a-diy-will-kit-and-an-online-will___au"
  }, {
    path: "/blog/posts/the-difference-between-estate-and-gifts",
    component: _7500c0f7,
    name: "the-difference-between-estate-and-gifts___au"
  }, {
    path: "/blog/posts/the-facts-and-fictions-youve-probably-heard-about-writing-a-will",
    component: _7500c0f7,
    name: "the-facts-and-fictions-youve-probably-heard-about-writing-a-will___au"
  }, {
    path: "/blog/posts/the-future-of-burial-plots-when-space-solutions-run-out",
    component: _7500c0f7,
    name: "the-future-of-burial-plots-when-space-solutions-run-out___au"
  }, {
    path: "/blog/posts/the-power-of-choosing-your-own-wake",
    component: _7500c0f7,
    name: "the-power-of-choosing-your-own-wake___au"
  }, {
    path: "/blog/posts/the-psychology-of-supporting-ageing-parents",
    component: _7500c0f7,
    name: "the-psychology-of-supporting-ageing-parents___au"
  }, {
    path: "/blog/posts/the-socio-economic-divide-in-estate-planning-which-australians-have-a-will",
    component: _7500c0f7,
    name: "the-socio-economic-divide-in-estate-planning-which-australians-have-a-will___au"
  }, {
    path: "/blog/posts/top-3-census-findings",
    component: _7500c0f7,
    name: "top-3-census-findings___au"
  }, {
    path: "/blog/posts/top-5-myths",
    component: _7500c0f7,
    name: "top-5-myths___au"
  }, {
    path: "/blog/posts/updating-wills",
    component: _7500c0f7,
    name: "updating-wills___au"
  }, {
    path: "/blog/posts/urns-for-ashes",
    component: _7500c0f7,
    name: "urns-for-ashes___au"
  }, {
    path: "/blog/posts/using-a-professional-executor",
    component: _7500c0f7,
    name: "using-a-professional-executor___au"
  }, {
    path: "/blog/posts/what-age-should-you-start-thinking-about-making-a-will",
    component: _7500c0f7,
    name: "what-age-should-you-start-thinking-about-making-a-will___au"
  }, {
    path: "/blog/posts/what-does-an-executor-of-a-will-actually-do",
    component: _7500c0f7,
    name: "what-does-an-executor-of-a-will-actually-do___au"
  }, {
    path: "/blog/posts/what-does-it-mean-if-a-letter-of-administration-is-contested",
    component: _7500c0f7,
    name: "what-does-it-mean-if-a-letter-of-administration-is-contested___au"
  }, {
    path: "/blog/posts/what-does-writing-a-will-have-to-do-with-financial-literacy",
    component: _7500c0f7,
    name: "what-does-writing-a-will-have-to-do-with-financial-literacy___au"
  }, {
    path: "/blog/posts/what-happens-if-i-die-abroad",
    component: _7500c0f7,
    name: "what-happens-if-i-die-abroad___au"
  }, {
    path: "/blog/posts/what-happens-if-you-cant-afford-aged-care-in-australia",
    component: _7500c0f7,
    name: "what-happens-if-you-cant-afford-aged-care-in-australia___au"
  }, {
    path: "/blog/posts/what-happens-to-bank-accounts-when-someone-dies-in-australia",
    component: _7500c0f7,
    name: "what-happens-to-bank-accounts-when-someone-dies-in-australia___au"
  }, {
    path: "/blog/posts/what-happens-to-debt-when-you-die",
    component: _7500c0f7,
    name: "what-happens-to-debt-when-you-die___au"
  }, {
    path: "/blog/posts/what-happens-to-my-children",
    component: _7500c0f7,
    name: "what-happens-to-my-children___au"
  }, {
    path: "/blog/posts/what-happens-to-my-social-media-when-i-die",
    component: _7500c0f7,
    name: "what-happens-to-my-social-media-when-i-die___au"
  }, {
    path: "/blog/posts/what-happens-to-my-socials-when-i-die",
    component: _7500c0f7,
    name: "what-happens-to-my-socials-when-i-die___au"
  }, {
    path: "/blog/posts/what-happens-to-your-pet-when-you-die",
    component: _7500c0f7,
    name: "what-happens-to-your-pet-when-you-die___au"
  }, {
    path: "/blog/posts/what-happens-to-your-property-when-you-pass-away",
    component: _7500c0f7,
    name: "what-happens-to-your-property-when-you-pass-away___au"
  }, {
    path: "/blog/posts/what-happens-to-your-superannuation-when-you-die",
    component: _7500c0f7,
    name: "what-happens-to-your-superannuation-when-you-die___au"
  }, {
    path: "/blog/posts/what-happens-when-executors-cant-agree",
    component: _7500c0f7,
    name: "what-happens-when-executors-cant-agree___au"
  }, {
    path: "/blog/posts/what-is-a-codicil-to-a-will",
    component: _7500c0f7,
    name: "what-is-a-codicil-to-a-will___au"
  }, {
    path: "/blog/posts/what-is-a-crematorium",
    component: _7500c0f7,
    name: "what-is-a-crematorium___au"
  }, {
    path: "/blog/posts/what-is-a-personal-legacy",
    component: _7500c0f7,
    name: "what-is-a-personal-legacy___au"
  }, {
    path: "/blog/posts/what-is-a-power-of-attorney",
    component: _7500c0f7,
    name: "what-is-a-power-of-attorney___au"
  }, {
    path: "/blog/posts/what-is-a-testamentary-trust",
    component: _7500c0f7,
    name: "what-is-a-testamentary-trust___au"
  }, {
    path: "/blog/posts/what-is-a-traditional-funeral",
    component: _7500c0f7,
    name: "what-is-a-traditional-funeral___au"
  }, {
    path: "/blog/posts/what-is-a-trust",
    component: _7500c0f7,
    name: "what-is-a-trust___au"
  }, {
    path: "/blog/posts/what-is-an-enduring-guardianship",
    component: _7500c0f7,
    name: "what-is-an-enduring-guardianship___au"
  }, {
    path: "/blog/posts/what-is-an-executor-and-how-do-you-choose-one",
    component: _7500c0f7,
    name: "what-is-an-executor-and-how-do-you-choose-one___au"
  }, {
    path: "/blog/posts/what-is-codicil-when-could-it-be-useful-for-you",
    component: _7500c0f7,
    name: "what-is-codicil-when-could-it-be-useful-for-you___au"
  }, {
    path: "/blog/posts/what-is-final-expense-life-insurance",
    component: _7500c0f7,
    name: "what-is-final-expense-life-insurance___au"
  }, {
    path: "/blog/posts/what-is-probate",
    component: _7500c0f7,
    name: "what-is-probate___au"
  }, {
    path: "/blog/posts/what-is-the-effect-of-marriage-and-divorce-on-your-will",
    component: _7500c0f7,
    name: "what-is-the-effect-of-marriage-and-divorce-on-your-will___au"
  }, {
    path: "/blog/posts/what-is-the-family-provisions-act-and-how-often-is-it-used-to-change-a-will",
    component: _7500c0f7,
    name: "what-is-the-family-provisions-act-and-how-often-is-it-used-to-change-a-will___au"
  }, {
    path: "/blog/posts/what-is-undue-influence-on-a-will-maker-how-to-protect-your-loved-ones",
    component: _7500c0f7,
    name: "what-is-undue-influence-on-a-will-maker-how-to-protect-your-loved-ones___au"
  }, {
    path: "/blog/posts/what-not-having-will-means-diego-maradona",
    component: _7500c0f7,
    name: "what-not-having-will-means-diego-maradona___au"
  }, {
    path: "/blog/posts/what-rights-do-beneficiaries-of-a-will-have",
    component: _7500c0f7,
    name: "what-rights-do-beneficiaries-of-a-will-have___au"
  }, {
    path: "/blog/posts/what-to-do-when-someone-dies",
    component: _7500c0f7,
    name: "what-to-do-when-someone-dies___au"
  }, {
    path: "/blog/posts/what-to-do-when-someone-dies-at-home",
    component: _7500c0f7,
    name: "what-to-do-when-someone-dies-at-home___au"
  }, {
    path: "/blog/posts/what-to-say-to-someone-in-grief-instead-of-sorry-for-your-loss",
    component: _7500c0f7,
    name: "what-to-say-to-someone-in-grief-instead-of-sorry-for-your-loss___au"
  }, {
    path: "/blog/posts/what-to-say-when-someone-dies",
    component: _7500c0f7,
    name: "what-to-say-when-someone-dies___au"
  }, {
    path: "/blog/posts/what-to-wear-to-a-funeral",
    component: _7500c0f7,
    name: "what-to-wear-to-a-funeral___au"
  }, {
    path: "/blog/posts/what-you-need-to-know-about-accepting-appointing-legal-guardianship",
    component: _7500c0f7,
    name: "what-you-need-to-know-about-accepting-appointing-legal-guardianship___au"
  }, {
    path: "/blog/posts/what-you-need-to-know-about-inheritance-how-it-works",
    component: _7500c0f7,
    name: "what-you-need-to-know-about-inheritance-how-it-works___au"
  }, {
    path: "/blog/posts/whats-the-difference-between-executor-vs-power-of-attorney",
    component: _7500c0f7,
    name: "whats-the-difference-between-executor-vs-power-of-attorney___au"
  }, {
    path: "/blog/posts/whats-the-key-difference-between-a-trust-estate-plan",
    component: _7500c0f7,
    name: "whats-the-key-difference-between-a-trust-estate-plan___au"
  }, {
    path: "/blog/posts/when-is-probate-necessary",
    component: _7500c0f7,
    name: "when-is-probate-necessary___au"
  }, {
    path: "/blog/posts/when-mothers-day-is-hard",
    component: _7500c0f7,
    name: "when-mothers-day-is-hard___au"
  }, {
    path: "/blog/posts/who-is-my-next-of-kin",
    component: _7500c0f7,
    name: "who-is-my-next-of-kin___au"
  }, {
    path: "/blog/posts/why-appoint-a-power-of-attorney",
    component: _7500c0f7,
    name: "why-appoint-a-power-of-attorney___au"
  }, {
    path: "/blog/posts/why-are-death-certificates-important-and-what-can-go-wrong",
    component: _7500c0f7,
    name: "why-are-death-certificates-important-and-what-can-go-wrong___au"
  }, {
    path: "/blog/posts/why-estate-planning-is-an-important-act-of-love",
    component: _7500c0f7,
    name: "why-estate-planning-is-an-important-act-of-love___au"
  }, {
    path: "/blog/posts/why-every-parent-needs-a-will",
    component: _7500c0f7,
    name: "why-every-parent-needs-a-will___au"
  }, {
    path: "/blog/posts/why-every-retiree-needs-a-will",
    component: _7500c0f7,
    name: "why-every-retiree-needs-a-will___au"
  }, {
    path: "/blog/posts/why-online-wills-matter-for-the-education-sector",
    component: _7500c0f7,
    name: "why-online-wills-matter-for-the-education-sector___au"
  }, {
    path: "/blog/posts/why-should-i-prepay-for-my-funeral",
    component: _7500c0f7,
    name: "why-should-i-prepay-for-my-funeral___au"
  }, {
    path: "/blog/posts/will-a-direct-cremation-harm-your-grieving-process",
    component: _7500c0f7,
    name: "will-a-direct-cremation-harm-your-grieving-process___au"
  }, {
    path: "/blog/posts/will-terminology",
    component: _7500c0f7,
    name: "will-terminology___au"
  }, {
    path: "/blog/posts/witnessing-wills-video-technology",
    component: _7500c0f7,
    name: "witnessing-wills-video-technology___au"
  }, {
    path: "/blog/posts/writing-a-death-notice",
    component: _7500c0f7,
    name: "writing-a-death-notice___au"
  }, {
    path: "/blog/posts/your-guide-to-cremation-jewellery",
    component: _7500c0f7,
    name: "your-guide-to-cremation-jewellery___au"
  }, {
    path: "/blog/posts/your-guide-to-planning-a-memorial-ceremony",
    component: _7500c0f7,
    name: "your-guide-to-planning-a-memorial-ceremony___au"
  }, {
    path: "/blog/author/:id?",
    component: _c6206cc6,
    name: "blog-author-id___au"
  }, {
    path: "/blog/guides/:slug",
    component: _7121d919,
    name: "blog-guides-slug___au"
  }, {
    path: "/blog/posts/:slug",
    component: _7500c0f7,
    name: "blog-posts-slug___au"
  }, {
    path: "/i/:code",
    component: _cc53f93e,
    name: "invite___au"
  }, {
    path: "/invites/:code?",
    component: _cc53f93e,
    name: "invites-code___au"
  }, {
    path: "/offers/:offer?",
    component: _83ecbba2,
    name: "offers-offer___au"
  }, {
    path: "/partners/:partner?",
    component: _e3b94e72,
    name: "partners-partner___au"
  }, {
    path: "/promotions/:promotion?",
    component: _4a4d76bd,
    name: "promotions-promotion___au"
  }, {
    path: "/",
    component: _98173ca8,
    name: "index___au"
  }, {
    path: "/*",
    component: _989b70dc,
    name: "catch-all___au"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
